import { type ReactNode } from "react";
import { IconCheck } from "@tabler/icons-react";
import Text, { type Color } from "../UI/Text";
import { AccordionItem } from "../UI/Accordion";
import styles from "./FiscaliteStep.module.css";

export type FiscaliteStepStatus = "done" | "active" | "pending";

interface FiscaliteStepProps {
  number: number;
  title: string;
  helper?: string;
  status: FiscaliteStepStatus;
  disabled?: boolean;
  children?: ReactNode;
}

export default function FiscaliteStep({
  number,
  title,
  helper,
  status,
  disabled = false,
  children,
}: FiscaliteStepProps) {
  const color: Color =
    status === "done" ? "success" : status === "active" ? "info" : "violet";

  return (
    <AccordionItem
      value={number}
      variant="plain"
      disabled={disabled}
      title={
        <>
          <Text
            as="span"
            color={color}
            weight="bold"
            background
            className={styles.statusCircle}
          >
            {status === "done" ? <IconCheck size={16} stroke={3} /> : number}
          </Text>
          <div>
            <Text as="div" weight="bold">
              {title}
            </Text>
            {helper && (
              <Text as="div" variant="deci" weight="medium" color="muted">
                {helper}
              </Text>
            )}
          </div>
        </>
      }
    >
      <div className={styles.panel}>{children}</div>
    </AccordionItem>
  );
}
